import Header from "@/components/landing/layout/Header";
import PlanHero from "./components/PlanHero";
import BrandBar from "./components/BrandBar";
import CoverageCards from "./components/CoverageCards";
import PlanCovers from "./components/PlanCovers";
import ClaimsHowItWorks from "./components/ClaimsHowItWorks";
import NotCovered from "./components/NotCovered";
import HowToBuyPlan from "./components/HowToBuyPlan";
import FAQSection from "./components/FAQSection";

const adCoverageItems = [
  {
    img: "/izicart/ad-product-1.png",
    title: "Drops and falls",
    text: "Cracks, breakage or malfunction after a drop",
  },
  {
    img: "/izicart/ad-product-2.png",
    title: "Single-event spills",
    text: "Accidental splashes or liquid ingress",
  },
  {
    img: "/izicart/ad-product-3.png",
    title: "Cameras and gimbals",
    text: "Cracked lens, display or housing; broken arms or motors",
  },
  {
    img: "/izicart/ad-product-4.png",
    title: "Smartwatches",
    text: "Cracked display or broken casing",
  },
];

const adFaqData = [
  {
    question: "What is a IZI Accidental Damage Plan?",
    answer:
      "IZI Care provides accidental damage coverage, extended warranty coverage and peace of mind. We get that accidents happen. That’s why with IZI Care, we’ll provide you with a replacement product should you need one. The enhanced coverage begins at the time of purchase, and covers until the end of the IZI Care Plan term length. See Terms and Conditions for additional details.",
  },
  {
    question: "Why should I add a Protega Product Protection?",
    answer:
      "Protega provides coverage for accidental damage not covered by the manufacturer’s warranty starting on day one. After your manufacturer warranty expires, you’re still covered in case of rips & tears for the remainder of your Protega coverage term.",
  },
  {
    question: "What happens if I return my product?",
    answer:
      "If you return your product, IZICart returns the amount you paid for your product protection. Depending on how much time has passed since your purchase, you may receive a prorated refund, less any paid service.",
  },
  {
    question:
      "I haven’t received a refund for my protection even though I returned my product.",
    answer:
      "IZICart handles all transactions for product protection sales and refunds. For assistance with refunds, contact our Customer Care.",
  },
  {
    question: "Is this plan the same as warranty or insurance?",
    answer:
      "No. It is an optional protection plan for accidental events, separate from any manufacturer warranty or insurance.",
  },
];

export default function index() {
  return (
    <div>
      {/* header */}
      <Header />

      {/* hero */}
      <PlanHero
        image="izi-accidental-hero.jpg"
        alt="IZI Accidental Plan - Action Camera"
        titleLines={["IZI Accidental Plan"]}
        descriptionLines={[
          "Protection against sudden accidental damage to your camera,",
          "gimbal or smartwatch — drops, knocks and single-event spills",
          "— for 12 or 24 months.",
        ]}
      />

      {/* brand section */}
      <BrandBar />

      {/* accidental damage protection */}
      <CoverageCards
        title="Accidental Damage Protection"
        subtitleLines={[
          "Covered for the accidents that happen on any shoot — after delivery, during normal use.",
          "Drones are not eligible.",
        ]}
        items={adCoverageItems}
      />

      {/* values section  */}
      <PlanCovers />

      {/* how it works */}
      <ClaimsHowItWorks />

      {/* not covered */}
      <NotCovered
        subtitle="A few things sit outside accidental damage. The Terms list everything in full."
        exclusions={[
          "Manufacturing defects",
          "Lens scratches that don’t affect image quality",
          "Water damage beyond the rated depth or with seals open",
          "Battery wear, memory cards or lost footage",
          "Use on a drone or in motorsport; dash cams in road accidents",
          "Theft, loss or damage in transit",
        ]}
      />

      {/* how to buy */}
      <HowToBuyPlan planName="IZI Accidental Damage Plan" />

      {/* faq section */}
      <FAQSection
        title="IZI Accidental Damage Plan FAQs"
        data={adFaqData}
        link="/izicart/tnc"
      />
    </div>
  );
}
